module.exports = __webpack_public_path__ + "static/media/periodIcon.e5a5833a.svg";